import { render, staticRenderFns } from "./PaymentSolicitations.vue?vue&type=template&id=ddfa763c&"
import script from "./PaymentSolicitations.js?vue&type=script&lang=js&"
export * from "./PaymentSolicitations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports